<template>
  <teleport to="body">
    <div
      v-if="show"
      class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      @click.self="$emit('close')"
    >
      <div class="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[80vh] overflow-hidden" role="document">
        <div class="border-b border-slate-200 px-6 py-4">
          <div class="flex items-center justify-between">
            <div class="text-xl font-semibold text-slate-800">
              <slot name="title">Modal</slot>
            </div>
            <button 
              type="button" 
              class="text-slate-400 hover:text-slate-600 text-2xl font-light leading-none bg-transparent border-0 p-0 outline-none" 
              aria-label="Close" 
              @click="$emit('close')"
            >
              &times;
            </button>
          </div>
        </div>
        <div class="p-6 overflow-y-auto max-h-[calc(80vh-120px)]">
          <slot />
        </div>
        <div class="border-t border-slate-200 px-6 py-4">
          <slot name="footer">
            <div class="flex justify-center">
              <button 
                type="button" 
                class="px-8 py-2.5 bg-slate-800 text-white rounded-md hover:bg-slate-900 transition-colors font-medium" 
                @click="$emit('close')"
              >
                Zamknij
              </button>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </teleport>
</template>
<script setup lang="ts">
import { onBeforeUnmount, watch } from 'vue';
const props = defineProps<{ show: boolean }>();

let prevOverflow: string = '';
function lockBody() {
  prevOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
}
function unlockBody() {
  document.body.style.overflow = prevOverflow || '';
}

watch(() => props.show, (val) => {
  if (val) lockBody();
  else unlockBody();
}, { immediate: true });

onBeforeUnmount(() => unlockBody());
</script>
